var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnitedKingdom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#071b65",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.1 0H0v3.25L25.9 24H30v-3.25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "M18.75 15 30 24v-2l-8.75-7zm-10-6h2.5L0 0v2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.1 24 30 3.25V0h-4.1L0 20.75V24z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 0h6v24h-6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 9h30v6H0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "M13 0h4v24h-4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "M30 10v4H0v-4zM18 7.59V9h.75L30 0h-2.42zM0 24h2.5l9.5-7.6V15h-.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedKingdom);
export default __webpack_public_path__ + "static/media/united-kingdom.5531363599a0322c2d671591f4da951f.svg";
export { ForwardRef as ReactComponent };